export const weekList = ['日', '一', '二', '三', '四', '五', '六'];


// getMonthDays(year, month)//传入参数年和月

export const getMonthDays = (y, m) => {
    var date = new Date();
    var year = y ? y : date.getFullYear(); //获取完整的年份(4位)
    var month = m ? m : (date.getMonth() + 1) < 9 ? (date.getMonth() + 1) : (date.getMonth() + 1);

    var currentDays = new Date(year, month, 0).getDate() // 当前月份多少天
    // var currentDay = Number(new Date().toLocaleDateString().split('/')[2]
    // ); // 获取当前是几号
    var stratDate = new Date(year, month - 1, 1),
        endData = new Date(year, month, 1);

    var days = (endData - stratDate) / (1000 * 60 * 60 * 24);
    var list = []
    for (var i = 1; i <= days; i++) {
        if (currentDays >= i) {
            const d = i > 9 ? i + '' : '0' + i
            const week = weekList[new Date((month) + '/' + i + '/' + year).getDay()]
            const m = month < 10 ? month : month

            list.push({
                month: m,
                week,
                d,
                fullDate: year + '-' + m + '-' + d
                // current: i === currentDay,
                // task: i === currentDay
            })
        }
        if (currentDays < i) {

            const d = (i - currentDays) > 9 ? (i - currentDays) + '' : '0' + (i - currentDays)
            const week = weekList[new Date((month + 1) + '/' + d + '/' + year).getDay()]
            const m = month < 10 ? '0' + month : month
             list.push({
                month: m,
                week,
                d,
                fullDate: year + '-' + m + 1 + '-' + d
                // current: i === currentDay,
                // task: null
            })
        }
    }
     return list

}

// 传入参数 new Date () 输出 '2023-06-09 10:02:20'
export const changeDateTime = (date) => {
     var regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (regex.test(date)) {
        return date;
    } else {


        let Y = date.getFullYear();
        let M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : '' + (date.getMonth() + 1)
        let D = date.getDate() < 10 ? '0' + (date.getDate()) : '' + date.getDate()

        let h = date.getHours() < 10 ? '0' + (date.getHours()) : '' + date.getHours()
        let m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : '' + date.getMinutes()
        let s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : '' + date.getSeconds()
        return `${Y}-${M}-${D} ${h}:${m}:${s}`
    }
}

// 传入参数 new Date () 输出 '2023-06-09'
export const changeDate = (date) => {
    let Y = date.getFullYear();
    let M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : '' + (date.getMonth() + 1)
    let D = date.getDate() < 10 ? '0' + (date.getDate()) : '' + date.getDate()
    return `${Y}-${M}-${D}`
}

/**
 * 图片压缩工具类
 * 最大高度和最大宽度都为 500，如果超出大小将等比例缩放。
 *
 * 注意可能出现压缩后比原图更大的情况，在调用的地方自己判断大小并决定上传压缩前或压缩后的图到服务器。
 */

// 将base64转换为blob
export function convertBase64UrlToBlob(urlData) {
    let arr = urlData.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
}


// 压缩图片
export function compressImage(path) {

    //最大高度
    const maxHeight = 500;
    //最大宽度
    const maxWidth = 500;

    return new Promise((resolve) => {
        let img = new Image();
        img.src = path;
        img.onload = function () {
            const originHeight = img.height;
            const originWidth = img.width;
            let compressedWidth = img.height;
            let compressedHeight = img.width;
            if ((originWidth > maxWidth) && (originHeight > maxHeight)) {
                // 更宽更高，
                if ((originHeight / originWidth) > (maxHeight / maxWidth)) {
                    // 更加严重的高窄型，确定最大高，压缩宽度
                    compressedHeight = maxHeight
                    compressedWidth = maxHeight * (originWidth / originHeight)
                } else {
                    //更加严重的矮宽型, 确定最大宽，压缩高度
                    compressedWidth = maxWidth
                    compressedHeight = maxWidth * (originHeight / originWidth)
                }
            } else if (originWidth > maxWidth && originHeight <= maxHeight) {
                // 更宽，但比较矮，以maxWidth作为基准
                compressedWidth = maxWidth
                compressedHeight = maxWidth * (originHeight / originWidth)
            } else if (originWidth <= maxWidth && originHeight > maxHeight) {
                // 比较窄，但很高，取maxHight为基准
                compressedHeight = maxHeight
                compressedWidth = maxHeight * (originWidth / originHeight)
            } else {
                // 符合宽高限制，不做压缩
            }
            // 生成canvas
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            canvas.height = compressedHeight;
            canvas.width = compressedWidth;
            context.clearRect(0, 0, compressedWidth, compressedHeight);
            context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
            let base64 = canvas.toDataURL('image/*', 0.8);
            let blob = convertBase64UrlToBlob(base64);
            // 回调函数返回blob的值。也可根据自己的需求返回base64的值
            resolve(blob)
        }
    })
}

// 判断数组中是否包含某项
export function contains(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].taskType === val.id) {
            return {
                isHave: true,
                index: i
            };
        }
    }
    return { isHave: false };
}
// 判断改类型的父级是否已经存在
export function containTypes(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].taskMiddleCate === val.parentId) {
            return {
                isHave: true,
                index: i
            };
        }
    }
    return { isHave: false };
}